import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, Input } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, BaseDataService, ModelDataService } from 'yt-ng-framework';
import { KarticaMpArtikla } from './kartica-mp-artikla';
import { FormGroup, FormControl } from '@angular/forms';


@Component({
    selector: 'yt-kartica-mp-artikla-modal',
    templateUrl: './kartica-mp-artikla-modal.component.html'
})
export class KarticaMpArtiklaModalComponent
    implements OnInit {

    @Input() ID;
    @Input() Parameters;
    @Input() parentProperty;
    baseFormGroup: FormGroup;
    Config = {}
    items;
    modelData;

    constructor(
        protected modalContainerService: ModalContainerService<KarticaMpArtikla>,
        protected activeModal: NgbActiveModal,
        protected baseDataService: BaseDataService,
        protected modelDataService: ModelDataService

    ) {
    }

    ngOnInit() {

        this.modelData = this.modelDataService.GetModelDataByPath("kartica-mp-artikla-modal");

        this.Config = {
            EditIcon: {
                Visible: false
            },
            DeleteIcon: {
                Visible: false
            },
            DefaultSortKey: this.modelData.MainList.SortBy,
            DefaultSortReverse: this.modelData.MainList.SortReverse,
            ShowIndex: false,
            ShowDefaultListButtons: false,
            Height: '100w',
            ShowCheckBoxes: false,
            PrintIcon: {
                Visible: false
            }
            , BreadCrumble: this.modelData.BreadcrumbLabel
        }

        this.baseDataService.Post('karticampartikla', 'GetByPeriodRobaAndKomitent'
            , { "DatumOd": this.Parameters[0].Value 
                ,  "DatumDo": this.Parameters[1].Value 
                ,  "KomitentID": this.Parameters[2].Value 
                ,  "RobaID": this.Parameters[3].Value 
                ,  "VrstaIzvestajaSinteticki": "false"
            }
            , KarticaMpArtikla)
            .subscribe(data => {
                this.items=data;
            })


    }

    Close() {
        this.activeModal.dismiss();
    }

}
